import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import WhatIs from "@/pages/WhatIs";
import Planets from "@/pages/Planets";
import MateriaMedica from "@/pages/MateriaMedica";
import CaseStudies from "@/pages/CaseStudies";
import Blog from "@/pages/Blog";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/what-is-astrohomeopathy" element={<WhatIs />} />
            <Route path="/planets" element={<Planets />} />
            <Route path="/materia-medica" element={<MateriaMedica />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
